export default __webpack_public_path__ + "static/media/img (3).bb2fd908.jpg";